import { authService } from "../../api/auth";
import { saveTokens, resetTokens } from "../../utils/cache";

export const SET_USER = "SET_USER";

export function login(email, password) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      authService.login(email, password).then(
        (response) => {
          console.log("login response", response);
          const user = response.user;
          const tokens = response.tokens;
          // console.log("user", user);
          // console.log("tokens", tokens);
          dispatch({ type: SET_USER, payload: user });
          saveTokens(tokens);
          resolve(tokens);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function getUser() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      authService.getUser().then(
        (user) => {
          console.log("user", user);
          dispatch({ type: SET_USER, payload: user });
          resolve(user);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function logout() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      resetTokens();
      window.location.href = "/";
      resolve();
    });
  };
}
